import { useState } from 'react';
import axios from 'axios';
import { logApiRequest } from '../components/common/mixpanelInterface';

// Utility for class components 
export const apiRequest = {
  get_and_post_data: async function(
    component,
    url,
    method = 'get',
    data = {},
    success_func_name = null,
    url_return = false,
    home_page = false,
    error_func_name = null,
    add_influencer_page_alterations = false
  ) {
    component.setState({ isLoading: true });
    const startTime = performance.now();

    try {
      const res = await axios({
        method: method,
        url: url,
        data: data,
        headers: {
          'Content-type': 'application/json',
        },
        withCredentials: true,
        maxContentLength: 100000000,
        maxBodyLength: 1000000000,
      });

      if (!res.data.access_denied) {
        if (method === 'get') {
          if (url_return) {
            window.location.assign(res.data.url);
          } else {
            if (add_influencer_page_alterations === true) {
              component.setState({
                alteredBio: res.data.influencer_info['description'],
                alteredDisplayName: res.data.influencer_info['influencer_name'],
              });
            }
          }
        } else if (method === 'post' && success_func_name) {
          success_func_name(res);
        }
      } else {
        if (res.data.url_return) {
          window.location.assign(res.data.url_return);
        } else {
          window.location.assign('/');
        }
      }

      return res;
    } catch (error) {
      if (error_func_name) {
        error_func_name(error);
      } else if (!home_page) {
        window.location.assign('/');
      }
      throw error;
    } finally {
      component.setState({ isLoading: false });
      logApiRequest(url, performance.now() - startTime);
    }
  }
};


// ## usage
// class MyComponent extends React.Component {
//   handleSubmit = async () => {
//     await apiRequest.get_and_post_data(
//       this,
//       '/api/endpoint',
//       'post',
//       false,
//       { data: 'value' },
//       (res) => console.log(res)
//     );
//   };
// }